
<template>
	<div class="fullguide" v-show="fullguidetype" @click.self="close" style="">
		<i class="fullguide__arrow"></i>
		<div class="fullguide__inner fullguide__inner--for-share">
			<div class="fullguide-share" options="[object Object]">
				<p class="fullguide-share__one">立即分享给好友吧</p>
				<p class="fullguide-share__two">点击屏幕右上角将本页面分享给好友</p>
			</div>
		</div>
	</div>
</template>
<script>
 export default {
	name:"fullguide",
	props:{
		fullguidetype:{
			type:Boolean,
			default:false,
		}
	},
	data(){
		return{
			
				msg:false,
		}
	},
	methods:{
		close(){
			this.$emit('funa',this.msg)
		}
	}

	}

</script>
<style scoped>
	.fullguide{
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.8);
	text-align: center;
	z-index: 2000;
}

.fullguide__arrow{

}


.fullguide__arrow {
    position: absolute;
    top: 12px;
    right: 33px;
    background: url("/static/images/share.png") no-repeat;
    width: 66px;
    height: 117px;
      background-size: 66px 117px;
}

.fullguide__inner--for-share{
padding-top: 140px;
}
.fullguide__inner{
	margin: 0 auto;
    width: 320px;
  
}
.fullguide-share{
	line-height: 30px;
	color: #fff;
	text-align: center;
}
.fullguide-share__one{
	font-size: 20px;
	font-weight: 500;

}
.fullguide-share__two{
	font-size: 14px;

}



@media only screen and (min-width: 321px){

.fullguide__arrow{
	background-image: url("/static/images/share.png");
    background-size: 66px 117px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/fullguide.vue